module.exports = __webpack_public_path__ + "fonts/5c90cd43-1e43-418c-b94c-e0687d8c2dc4.0fb8409e.eot";